export default {
  black: '#000000',
  white: '#FFFFFF',
  eucalyptus050: '#F7F7F8',
  eucalyptus100: '#F3F3F4',
  eucalyptus200: '#D8DBDF',
  eucalyptus300: '#BDC4C9',
  eucalyptus400: '#8C96A3',
  eucalyptus500: '#5F6B7A',
  eucalyptus600: '#4E5A6A',
  eucalyptus700: '#384452',
  eucalyptus800: '#262F3B',
  eucalyptus900: '#1A2029',
  cornflower050: '#F7FAFC',
  cornflower100: '#EDF6FC',
  cornflower200: '#DEE8FC',
  cornflower300: '#BACDFC',
  cornflower400: '#8EA0FA',
  cornflower500: '#5D62F9',
  // primary
  cornflower600: '#3F37DE',
  cornflower700: '#131B86',
  cornflower800: '#221A68',
  cornflower900: '#100D29',
  wildrose200: '#F7F5F2',
  wildrose500: '#FFDDCE',
  // primary
  dahlia100: '#E7F8EA',
  dahlia500: '#ADE1B9',
  // primary
  dahlia800: '#22442E',
  orchid100: '#FBE4E4',
  orchid500: '#E16969',
  orchid800: '#552320',
  dandelion100: '#FDF6E2',
  dandelion500: '#F1D049',
  // primary
  dandelion800: '#544917',
  rose: '#ED5E59',
  amaranth: '#53CB8B',
  tulip: '#F19C42',
  lavender: '#9940F1',
  tobacco: '#8C6326'
};